import { apiBaseURL } from '../ProjectConstants';

/*
 =-=-=-=-=- data structure -=-=-=-=-=
	orderedBy: str,
	vendors: [{
		name:
			items: [{
				billingCode: str,
				deliveryLocationId: int,
				isOutOfStock: bool,
				itemName: str,
				itemNumber: str,
				notes: str,
				pricePerItem: int,
				quantity: int,
				url: str,
			}],
		}],
	urgency: int,
*/
async function handlePostAddOrderForOther(requestorContactNumber, vendors, urgency, userId, fetch, reasoning) {
	const body = {
		orderedBy: userId,
		requesetorContactNumber: requestorContactNumber, 
		vendors: vendors,
		urgency: urgency,
		UrgencyJustification: reasoning || "", 
	}
	//const response = false
	const response = await fetch.post(`${apiBaseURL}/api/orders/user`, body);
	const isDataGood = response?.success && response?.data?.statusCode && response?.success !== 'Invalid Model';

	console.log('handlePostAddOrderForOther body', body);
	console.log('handlePostAddOrderForOther response', response);

	return {
		response,
		isDataGood
	};
}
export default handlePostAddOrderForOther;